<template>
  <div class="orderHeader">
    <div class="orderHeaderItem">
      <div class="allOrder">全部询盘</div>
      <div class="borderLine"></div>
      <div class="allOrder activeItem">
        <span>企业采购系统直连订单</span>
      </div>
    </div>
    <div class="orderHeaderSeach">
      <el-input placeholder="搜索询盘编号、采购商、零件名称、询盘标题" class="sizeInput" v-model="keyword" size="medium" clearable @clear="searchWord" @keyup.enter.native="searchWord">
        <template slot="prefix">
          <i class="iconfont icon-icon-fangdajing"></i>
        </template>
        <template slot="append">
          <div class="searchBtn" @click="searchWord">搜索</div>
        </template>
      </el-input>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        keyword:'',
      }
    },
    methods:{
      searchWord(){
        // console.log('search')
        this.$emit('searchWord',this.keyword)
      }
    }
  }
</script>

<style lang="scss" scoped>
.orderHeader{
  min-width:calc(100% - 230px);
  height: 84px;
  background:url('~@/assets/image/zhenyunOrder/head.png') no-repeat center 100%;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  padding: 0 24px;
  position: fixed;
  z-index: 6;
  .orderHeaderItem{
    display: flex;
    flex: 1;
    align-items: center;
    height: 24px;
    .allOrder{
      color: #222222;
      font-size: 16px;
      // padding: 0px 16px;
      height: 24px;
      position: relative;
    }
    .borderLine{
      background: #98A3B7;
      border-radius: 2px;
      width: 1px;
      height: 16px;
      flex-shrink: 0;
      margin: 0px 16px;
    }
    .activeItem{
      color: #0863ff;
      height: 24px;
    }
    .activeItem :after {
      content: "";
      position: absolute;
      bottom: 1px;
      left: 0;
      width: 60px;
      height: 4px;
      border-radius: 10px;
      opacity: .5;
      background: linear-gradient(90deg, #0863ff99 0%, #0863ff00 61.54%);
    }
  }
  :deep(.orderHeaderSeach){
    margin-left: auto;
    min-width: 540px;
    .sizeInput{
      height: 42px;
      .el-input__inner{
         height: 42px;
         border: 1px solid #0863FF;
         border-radius: 999px 0 0 999px;
         border-right: 0px;
         padding-left: 42px;
      }
      ::placeholder{
        color: #98a3b7;
        font-size: 16px;
      }
      .el-input-group__append{
        border: 1px solid #0863FF;
        border-left: 0px;
        border-radius: 0 999px 999px 0 ;
        background-color:#fff;
        padding:0 4px 0 0;
        .searchBtn{
          height: 34px;
          width: 64px;
          background: #0863FF;
          border-radius: 999px;
          color: #fff;
          text-align: center;
          line-height: 34px;
          font-size: 16px;
          cursor: pointer;
        }
      }
      .el-input__prefix{
        font-size:15.39px;
        color: #98A3B7;
        display: flex;
        align-items: center;
        padding-left: 16px;
      }
    }
  }
}
</style>